import { Box, Stack } from '@chakra-ui/react'

import type { ConversationMembersModalConversationFragment } from '@/client/services/hasura/generated/graphql'
import { getUserUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import ModalV3 from '@/components/UI/Modal/ModalV3'
import AvatarWithName from '@/components/Worlds/UI/Avatar/AvatarWithName'

export default function ConversationMembersModal({
  open,
  onClose,
  conversation,
}: {
  open: boolean
  onClose: () => void
  conversation: ConversationMembersModalConversationFragment
}): React.ReactElement {
  const users = conversation.conversation_users

  return (
    <ModalV3
      open={open}
      onClose={onClose}
      title={`Members (${users.length})`}
      body={() => (
        <Stack spacing="0px" direction="column">
          {users.map(({ user }) => (
            <ShwLink
              href={getUserUrl({ userId: user.id, username: user.username })}
              width="100%"
              key={`${user.id}`}
            >
              <Box
                _hover={{ bg: 'bg.muted' }}
                width="100%"
                p="12px"
                borderRadius="8px"
                cursor="pointer"
              >
                <AvatarWithName user={user} />
              </Box>
            </ShwLink>
          ))}
        </Stack>
      )}
    />
  )
}
